export const OTP_LENGTH = 6
export const ONLY_NUMERIC_REGEX = /^\d*$/
export const EXACT_NUMERIC_REGEX = /^\d$/
export const PASSCODE_EXPIRED_TIME = 30
export const PASSCODE_EXPIRED_TIME_EBAY = 10
export const TYPE = "type"
export const VALUE = "value"
export const TEXT = "text"
export const TIMER_KEY = "resend_otp_timer"
export const EXPIRATION_DURATION_TYPE = "sec"
